import React from 'react';
import PropTypes from 'prop-types';
import { intlMessage } from 'constants/propTypes';
import Button from 'components/Button';
import Message from 'components/Message';

function AddButton({ message, handleAddClick }) {
  return <Message as={Button} onClick={handleAddClick} message={message} data-cypress="add-button" />;
}

AddButton.propTypes = {
  message: intlMessage,
  handleAddClick: PropTypes.func,
};

export default AddButton;
